import React, {useCallback, useEffect, useState} from "react";

import './CallsTable.scss'
import {ADD, useToastContext} from "../Toast";
import {useNavigate} from "react-router-dom";
import {useRecoilState, useRecoilValue} from "recoil";
import {deleteModalIdState, deleteModalOpenState,} from "../../state/users_table";
import {grpcCallServiceSelector} from "../../state/grpc";
import {
  Button,
  DataTable,
  DataTableSkeleton,
  Modal, OverflowMenu, OverflowMenuItem, Pagination, Table,
  TableBody, TableCell,
  TableContainer, TableHead, TableHeader, TableRow,
  TableToolbar, TableToolbarContent, TableToolbarSearch
} from "@carbon/react";

const CallsTable = () => {
  const headers = [{
    key: 'systemName', header: 'Sistema'
  }, {
    key: 'deviceCode', header: 'Strumento'
  }, {
    key: 'alarmCode', header: 'Codice allarme'
  }, {
    key: 'fromHour', header: 'Da'
  }, {
    key: 'toHour', header: 'A'
  }];

  const {toastDispatch} = useToastContext();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)
  const [rows, setRows] = useState([])
  const [firstRowIndex, setFirstRowIndex] = useState(0)
  const [pageSize, setPageSize] = useState(25)
  const [deleteModalOpen, setDeleteModalOpen] = useRecoilState(deleteModalOpenState)
  const [deleteModalId, setDeleteModalId] = useRecoilState(deleteModalIdState)
  const callService = useRecoilValue(grpcCallServiceSelector)

  const navigateToAdd = useCallback(() => {
    navigate('/system/calls/add')
  }, [navigate])

  const navigateToEdit = useCallback((id) => {
    navigate('/system/calls/' + id)
  }, [navigate])

  function getCallsTableData() {
    const req = new proto.api.ListCallsConfigsRequest();
    callService.listCallsConfigs(req, null, (err, resp) => {
      if (err != null) {
        setError(true)
      } else {
        setRows(resp.toObject().callsConfigsList)
        setLoading(false)
      }
    })
  }

  useEffect(() => {
    getCallsTableData();
  }, []);

  if (loading) {
    return (<DataTableSkeleton
      columnCount={headers.length + 1}
      rowCount={5}
      headers={headers}
    />)
  }

  if (error) {
    return (<div>
      <span>ERROR!</span>
    </div>)
  }

  const handlePaginationChange = (page, newPageSize) => {
    if (newPageSize !== pageSize) {
      setPageSize(newPageSize);
    }
    setFirstRowIndex(newPageSize * (page - 1));
  }

  return (<DataTable
    rows={rows}
    headers={headers}
    isSortable
    render={({
               rows,
               headers,
               getHeaderProps,
               getRowProps,
               getToolbarProps,
               onInputChange,
               getTableProps,
               getTableContainerProps,
             }) => {
      return (
        <TableContainer title="Configurazioni chiamate"
                        description="Lista delle configurazioni attive" {...getTableContainerProps()}>
          <Modal
            open={deleteModalOpen}
            danger
            modalHeading={"Sei sicuro di voler eliminare la configurazione " + deleteModalId + " ?"}
            modalLabel="Elimina configurazione"
            primaryButtonText="Elimina"
            onRequestSubmit={() => {
              const req = new proto.api.DeleteCallConfigRequest()
              req.setCallConfigId(deleteModalId)
              callService.deleteCallConfig(req, null, (err, resp) => {
                if (err != null) {
                  console.error(err)
                  toastDispatch({
                    type: ADD,
                    payload: {
                      title: "Operazione fallita",
                      content: "Impossibile eliminare la configurazione",
                      kind: "error",
                      caption: err.message
                    }
                  })
                } else {
                  getCallsTableData()
                  setDeleteModalOpen(false)
                  toastDispatch({
                    type: ADD,
                    payload: {
                      title: "Operazione avvenuta con successo",
                      content: "Configurazione eliminata con sucesso",
                      kind: "success"
                    }
                  })
                }
              })
            }}
            onRequestClose={() => {
              setDeleteModalOpen(false)
            }}
            secondaryButtonText="Annulla"
          />
          <TableToolbar {...getToolbarProps()} >
            <TableToolbarContent>
              <TableToolbarSearch onChange={onInputChange} size="lg"/>
              <Button onClick={navigateToAdd}>Nuova configurazione</Button>
            </TableToolbarContent>
          </TableToolbar>
          <Pagination
            totalItems={rows.length}
            backwardText="Precedente"
            forwardText="Successiva"
            pageSize={pageSize}
            pageSizes={[10, 25, 50, 100]}
            itemsPerPageText="Elementi per pagina"
            pageRangeText={(_current, total) => `di ${total} ${total === 1 ? 'pagina' : 'pagine'}`}
            itemRangeText={(min, max, total) => `${min}–${max} of ${total} elementi`}
            onChange={({page, pageSize}) => handlePaginationChange(page, pageSize)}
          />
          <Table {...getTableProps()}>
            <TableHead>
              <TableRow>
                {headers.map((header) => (<TableHeader {...getHeaderProps({header})}>
                  {header.header}
                </TableHeader>))}
                <TableHeader style={{width: '1rem'}} scope="col"/>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.slice(firstRowIndex, firstRowIndex + pageSize).map((row) => (<TableRow key={row.id} {...getRowProps({row})}>
                {row.cells.map((cell) => (<TableCell key={cell.id}>
                  {cell.value}
                </TableCell>))}
                <TableCell className="cds--table-column-menu">
                  <OverflowMenu flipped size='md' aria-label="">
                    <OverflowMenuItem itemText="Modifica" onClick={() => navigateToEdit(row.id)}/>
                    <OverflowMenuItem isDelete itemText="Elimina"
                                      onClick={() => {
                                        setDeleteModalId(row.id)
                                        setDeleteModalOpen(true)
                                      }}/>
                  </OverflowMenu>
                </TableCell>
              </TableRow>))}
            </TableBody>
          </Table>
        </TableContainer>);
    }}
  />)
}

export default CallsTable